import gql from 'graphql-tag';

export default gql`
  fragment FragmentAuditLog on AuditLog {
    actionName
    actionMetadata
    userName
    userEmail
    originIp
    originUrl
    logTraceId
    logTime
    uId
    __typename
  }
`;
